import bikeAvailableIcon from '../../assets/bikeAvailableIcon.png';
import bikeRentedIcon from '../../assets/bikeRentedIcon.png';
import { BikeTechnicalStatusOptions } from './BikesListModel';

const normalizeTechnicalStatus = (technicalStatus, isMissing) => {
  if (typeof technicalStatus === 'number') {
    if (technicalStatus === 2) return BikeTechnicalStatusOptions.missing.value;
    if (technicalStatus === 1) return BikeTechnicalStatusOptions.damaged.value;
    return BikeTechnicalStatusOptions.functional.value;
  }

  if (technicalStatus) {
    const status = technicalStatus.charAt(0).toLowerCase() + technicalStatus.slice(1);
    if (BikeTechnicalStatusOptions[status]) return status;
  }

  return isMissing
    ? BikeTechnicalStatusOptions.missing.value
    : BikeTechnicalStatusOptions.functional.value;
};

export class BikeRecordModel {
  constructor(data) {
    this.id = data.id;
    this.bikeNumber = data.bikeNumber;
    this.lockImei = data.lockImei;
    this.lockPhoneNumber = data.lockPhoneNumber;
    this.lockBatteryLevel = data.lockBatteryLevel;
    this.bikeBatteryLevel = data.bikeBatteryLevel != null && data.bikeBatteryLevel >=0 && data.bikeBatteryLevel <= 100 ? data.bikeBatteryLevel : null;
    this.lockFirmware = data.lockFirmware;
    this.lockState = data.lockState;
    this.shackleState = data.shackleState;
    this.insideOperationsZone = data.insideOperationsZone;
    this.lockTimestamp = data.lockTimestamp;
    this.gpsTimestamp = data.gpsTimestamp;
    this.satellites = data.satellites;
    this.isAvailableForRental = data.isAvailableForRental;
    this.isRentalRestricted = data.isRentalRestricted;
    this.technicalStatus = normalizeTechnicalStatus(data.technicalStatus, data.isMissing);
    this.isMissing = this.technicalStatus === BikeTechnicalStatusOptions.missing.value;
    this.rentalRestrictionReason = data.rentalRestrictionReason;
    this.isReserved = data.isReserved;
    this.isRented = data.isRented;
    this.hasAlarmEnabled = data.hasAlarmEnabled;
    this.isOrientedUpright = data.isOrientedUpright;
    this.bikeIcon = data.icon ? data.icon : (this.isAvailableForRental ? bikeAvailableIcon : bikeRentedIcon);
    this.isSponsored = data.isSponsored || false;
    this.internalUseOnly = data.internalUseOnly;
    this.typeName = data.typeName;
    this.ongoingPause = data.ongoingPause;
    this.agps = data.agps;
    this.tenant = data.tenant;
    this.lastRideDate = data.lastRideDate;
    this.lastRideId = data.lastRideId;
    this.lastRideUrl = data.lastRideId ? `https://${this.tenant}.roovee.eu/reports/rides/${this.lastRideId}` : null;
    this.lockDeviceType = data.lockDeviceType;
  }
}
